import { render } from "./gphg.vue?vue&type=template&id=1be55da2&scoped=true&ts=true"
import script from "./gphg.vue?vue&type=script&lang=ts"
export * from "./gphg.vue?vue&type=script&lang=ts"

import "./gphg.vue?vue&type=style&index=0&id=1be55da2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be55da2"]])

export default __exports__